/* Registers the Service Worker once the page is loaded. Bails out in dev
 * (CRA's webpack-dev-server doesn't serve from the root) and on browsers
 * without serviceWorker support. */
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register on the production build served from the same origin
  if (window.location.hostname === "localhost") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // eslint-disable-next-line no-console
      console.warn("[OncoCadence] SW registration failed:", err);
    });
  });
}
